import { ajax } from "@/assets/js/ajax";
import store from "@/store";
export function oneAdd(data, StepLite) {
  //一审立案审查中
  return ajax({
    url:
      StepLite == 10 || StepLite == 121 || StepLite == 15
        ? "step/lascz/one/add"
        : StepLite == 70 || StepLite == 115
        ? "step/lascz/two/add"
        : "step/lascz/three/add",
    data: data,
  });
}

export function oneEdit(data, StepLite) {
  //一审立案审查中修改
  return ajax({
    updateTime: store.state.updateTime,
    url:
      StepLite == 10 || StepLite == 121 || StepLite == 15
        ? "step/lascz/one/edit"
        : StepLite == 70 || StepLite == 115
        ? "step/lascz/two/edit"
        : "step/lascz/three/edit",
    data: data,
  });
}

export function lasczDetails(data) {
  //一审详情
  return ajax({
    url: "step/lascz/lists",
    data: data,
    type: "get",
  });
}

export function jzyjAdd(data, StepLite) {
  //卷宗移交时间
  return ajax({
    url: "step/jzyj/add",
    data: data,
  });
}

export function jzyjEdit(data) {
  //卷宗移交时间
  return ajax({
    updateTime: store.state.updateTime,
    url: "step/jzyj/edit",
    data: data,
    contentType: "application/json",
  });
}

export function jzyjLists(data) {
  //卷宗移交时间
  return ajax({
    url: "step/jzyj/lists",
    data: data,
    type: "get",
  });
}

export function ssclzbAdd(data, StepLite) {
  //诉讼材料制作
  return ajax({
    url: "step/ssclzb/add",
    data: data,
  });
}

export function ssclzbEdit(data) {
  //卷宗移交时间
  return ajax({
    url: "step/ssclzb/edit",
    data: data,
    updateTime: store.state.updateTime,
  });
}

export function ssclzbLists(data) {
  //卷宗移交时间
  return ajax({
    url: "step/ssclzb/lists",
    data: data,
    type: "get",
  });
}

export function jcyspjdAdd(data, StepLite) {
  //涉刑案件侦查添加//中止/终止审理
  return ajax({
    url: StepLite == "120" ? "step/sxajzc/add" : "step/jcyspjd/add",
    data: data,
    contentType: "application/json",
  });
}

export function jcyspjdEdit(data, StepLite) {
  //涉刑案件侦查修改
  return ajax({
    url: StepLite == "120" ? "step/sxajzc/edit" : "step/jcyspjd/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}

export function jcyspjdLists(data, StepLite) {
  //涉刑案件侦查列表
  return ajax({
    url: StepLite == "120" ? "step/sxajzc/lists" : "step/jcyspjd/lists",
    data: data,
    type: "get",
  });
}

export function twosAdd(data) {
  //一审调节新增
  return ajax({
    url: "step/stz/add",
    data: data,
    contentType: "application/json",
  });
}
export function twosEdit(data) {
  //一审调度修改
  return ajax({
    url: "step/stz/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}
export function twosDetails(data) {
  //一审详情
  return ajax({
    url: "step/stz/lists",
    data: data,
    type: "get",
  });
}
export function laAdd(data) {
  //一审立案 新增
  return ajax({
    url: "step/la/add",
    data: data,
    contentType: "application/json",
  });
}

export function laEdit(data) {
  //一审立案 修改
  return ajax({
    url: "step/la/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}

export function laDetails(data) {
  //一审立案详情
  return ajax({
    url: "step/la/lists",
    data: data,
    type: "get",
  });
}

export function dktAdd(data) {
  // 一审待开庭
  return ajax({
    url: "step/dkt/add",
    data: data,
    contentType: "application/json",
  });
}
export function dktEdit(data) {
  return ajax({
    url: "step/dkt/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}
export function dktDetails(data) {
  return ajax({
    url: "step/dkt/lists",
    data: data,
    type: "get",
  });
}

export function dpjAdd(data) {
  // 一审待判决
  return ajax({
    url: "step/dpj/add",
    data: data,
    contentType: "application/json",
  });
}
export function dpjEdit(data) {
  return ajax({
    url: "step/dpj/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}
export function dpjList(data) {
  return ajax({
    url: "step/dpj/lists",
    data: data,
    type: "get",
  });
}

export function cpwsAdd(data) {
  // 一审裁判文书;
  return ajax({
    url: "step/cpws/add",
    data: data,
    contentType: "application/json",
  });
}
export function cpwsEdit(data) {
  return ajax({
    url: "step/cpws/edit",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}
export function cpwsList(data) {
  return ajax({
    url: "step/cpws/lists",
    data: data,
    type: "get",
  });
}

export function zsAdd(data) {
  //再审
  return ajax({
    url: "step/zs/add",
    data: data,
  });
}

export function zsEdit(data) {
  //修改
  return ajax({
    url: "step/zs/edit",
    data: data,
    contentType: "application/json",
  });
}

export function zsLists(data) {
  //再审详情
  return ajax({
    url: "step/zs/lists",
    data: data,
    type: "get",
  });
}

const zblast = {
  150: {
    //执行中
    add: "step/zxz/add",
    edit: "step/zxz/edit",
    lists: "step/zxz/lists",
  },
  160: {
    //终本
    add: "step/zb/add",
    edit: "step/zb/edit",
    lists: "step/zb/lists",
  },
  170: {
    // 恢复执行
    add: "step/hfzx/add",
    edit: "step/hfzx/edit",
    lists: "step/hfzx/lists",
  },
  180: {
    add: "step/ja/add",
    edit: "step/ja/edit",
    lists: "step/ja/lists",
  },
  181: {
    add: "debtor/set_clear",
    edit: "debtor/edit_clear",
  },
};
export function zblastAdd(data, key) {
  //执行中
  return ajax({
    url: zblast[key].add,
    data: data,
    contentType: "application/json",
  });
}

export function zblastEdit(data, key) {
  //执行中修改
  return ajax({
    url: zblast[key].edit,
    type: key == 181 ? "put" : "post",
    data: data,
    contentType: "application/json",
    updateTime: store.state.updateTime,
  });
}

export function zblastDel(data) {
  //执行中修改
  return ajax({
    url: "debtor/del_clear",
    type: "delete",
    data: data,
  });
}
export function zblastLists(data, key) {
  //执行中详情
  if (key == 181) {
    return new Promise((resolve, reject) => {
      resolve({
        list: [{ jq: JSON.parse(JSON.stringify(store.getters.debInfo.clear)) }],
      });
    });
  } else {
    return ajax({
      url: zblast[key].lists,
      data: data,
      type: "get",
    });
  }
}
export function with_debtor(data) {
  //执行中详情
  return ajax({
    url: "cause/accuser_with_debtor",
    data: data,
    type: "get",
  });
}

export function delJd(data) {
  return ajax({
    url: "step/delete",
    data: data,
    type: "get",
  });
}
